module.exports = __webpack_public_path__ + "img/anf7.c93fde5a.png";